import { render, staticRenderFns } from "./warehouse-information.vue?vue&type=template&id=398f05dd&scoped=true&"
import script from "./warehouse-information.vue?vue&type=script&lang=js&"
export * from "./warehouse-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "398f05dd",
  null
  
)

export default component.exports